'use strict'
module.exports = {
    NODE_ENV: '"production"',
    API_LIST: {
        FO: '"widgets.habiteo.com"',
        REVIEW: '"review.habiteo.com"'
    },
    S3_URL: '"https://s3-eu-west-1.amazonaws.com/media.habiteo.com/scripts"',
    REVIEW_HABITEO_URL: '"review.habiteo.com"',
    PRESTA_HABITEO_URL: '"presta.habiteo.com/review"',
    MATERIAL_PREVIEW: '"https://configurateur.habiteo.com/back/material/"',
    PREFAB_PREVIEW: '"https://configurateur.habiteo.com/back/prefab/"',
    PROMOTER_SPACE: '"https://my.habiteo.com/"',
    FUNNEL_URL: '"https://funnel.habiteo.com/"',
    WIDGET_CORE: {
        ENV: {
            VERSION: 72,
            API_URL: '"api.habiteo.com"',
            RESOURCES_URL: '"widgets.habiteo.com"',
            S3_SCRIPTS_URL: '"https://s3-eu-west-1.amazonaws.com/media.habiteo.com/scripts"',
            STATIC_RESOURCES_URL: '"https://dhge9bzu10gaf.cloudfront.net/assets/widgets/statics/"',
            KRPANO_SKIN_URL: '"https://dhge9bzu10gaf.cloudfront.net/assets/widgets/statics/vtour/1.20/"'
        },
        SCRIPTS: {
            API: '"s3-eu-west-1.amazonaws.com/media.habiteo.com/scripts/habiteo.api.js"',
            CORE: '"s3-eu-west-1.amazonaws.com/media.habiteo.com/scripts/habiteo.core.js"',
            WIDGETS: '"s3-eu-west-1.amazonaws.com/media.habiteo.com/scripts/habiteo.widgets.js"',
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 2